import React from 'react';
import { useTranslation } from '@michelin/central-provider';
import { BillingServiceTypes } from '../types';

interface ServiceLabelProps {
  service: string;
  profile: 'ERS' | 'On-site';
  isMdOrLarger: boolean;
}

export const ServiceLabel: React.FC<ServiceLabelProps> = ({ service, profile, isMdOrLarger }) => {
  const { t } = useTranslation();
  const serviceText = service === BillingServiceTypes.MECHANICAL ? 'Mechanical' : 'Tire';
  const text = `${serviceText} ${profile} Service`;
  return <div style={{ paddingTop: isMdOrLarger ? 15 : 0, paddingLeft: isMdOrLarger ? 5 : 0 }}>{t(text)}</div>;
};
